import type { DayOfWeek } from '../../enum/dayOfWeek';

export type TimeRange = {
  start: string;
  end: string;
};

export type DayOfWeekOpening = {
  days: Partial<Record<DayOfWeek, Opening>>;
};

export enum OpeningHoursType {
  CONSTANT = 'CONSTANT',
  DAILY = 'DAILY',
}

export type Opening =
  | {
      isAllDay: true;
    }
  | { isAllDay: false; slots: TimeRange[] };

export type OpeningHours =
  | { type: 'CONSTANT'; configuration: TimeRange }
  | {
      type: 'DAILY';
      days: Partial<Record<DayOfWeek, TimeRange>>;
    };
